import React, { useContext } from 'react'
import Button from '../../Button'
import { FieldsetContext, FormContext } from '../context'

interface IClearButtonProps {
  icon: React.ReactElement
  children: React.ReactNode
  fullWidth?: boolean
}

const ClearButton = ({ icon, children, fullWidth }: IClearButtonProps) => {
  const { form, deleteFormValue, setFormMetaData } = useContext(FormContext)

  const { isInsideFieldset, inputs } = useContext(FieldsetContext)

  const clearForm = () => {
    if (isInsideFieldset) {
      inputs.forEach(key => {
        deleteFormValue(key, false)
      })
    } else {
      Object.keys(form).forEach(key => {
        deleteFormValue(key, false)
      })
      setFormMetaData({ submitted: false })
    }
  }

  const variant = isInsideFieldset ? 'text-flat' : 'outlined-rounded'

  return (
    <Button
      leadingIcon={icon}
      variant={variant}
      onClick={clearForm}
      size="small"
      fullWidth={fullWidth}
    >
      {children}
    </Button>
  )
}

ClearButton.displayName = 'Form.ClearButton'
export default ClearButton
